export default "__VITE_ASSET__KD3GfvtS__"